// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as PilotStemHeading$LiteracyplanetTupperware from "../v3/PilotStemHeading.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";

function SkilfulStemHeading(props) {
  var children = props.children;
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(PilotStemHeading$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement("div", {
                className: Skillet$LiteracyplanetTupperware.SkilfulStemHeading.className
              }, children);
  }
}

var make = SkilfulStemHeading;

var $$default = SkilfulStemHeading;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
